<script lang="ts">
  import { store } from '$lib/store.svelte';
  import type { ViewName } from '$lib/types';

  interface Props { open: boolean; onClose: () => void; onNavigate: (v: string) => void }
  let { open, onClose, onNavigate }: Props = $props();

  const nav: { id: ViewName; label: string }[] = [
    { id: 'ideas', label: 'Embudo' },
    { id: 'agentes', label: 'Tocado por agentes' },
    { id: 'archivo', label: 'Archivo GTD' },
    { id: 'sync', label: 'Sincronizar' }
  ];

  function go(v: ViewName) {
    store.setView(v);
    onNavigate(v);
  }
</script>

<aside class="sidebar" class:open>
  <div class="sidebar-header">
    <div class="sidebar-title">Kairos</div>
    <div class="sidebar-sub">Embudo de ideas</div>
  </div>
  <nav class="sidebar-nav">
    {#each nav as n}
      <button type="button" class="nav-item" class:active={store.view === n.id} onclick={() => go(n.id)}>
        <span>{n.label}</span>
        {#if n.id === 'agentes' && store.pendientes.length > 0}<span class="nav-badge">{store.pendientes.length}</span>{/if}
      </button>
    {/each}
  </nav>
</aside>
